// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
export var DataTypes;
(function (DataTypes) {
    DataTypes[DataTypes["null"] = 0] = "null";
    DataTypes[DataTypes["string"] = 1] = "string";
    DataTypes[DataTypes["number"] = 2] = "number";
    DataTypes[DataTypes["boolean"] = 3] = "boolean";
})(DataTypes || (DataTypes = {}));
export var DocPropsModifiableElements;
(function (DocPropsModifiableElements) {
    DocPropsModifiableElements["title"] = "dc:title";
    DocPropsModifiableElements["subject"] = "dc:subject";
    DocPropsModifiableElements["keywords"] = "cp:keywords";
    DocPropsModifiableElements["createdBy"] = "dc:creator";
    DocPropsModifiableElements["description"] = "dc:description";
    DocPropsModifiableElements["lastModifiedBy"] = "cp:lastModifiedBy";
    DocPropsModifiableElements["category"] = "cp:category";
    DocPropsModifiableElements["revision"] = "cp:revision";
})(DocPropsModifiableElements || (DocPropsModifiableElements = {}));
export var DocPropsAutoUpdatedElements;
(function (DocPropsAutoUpdatedElements) {
    DocPropsAutoUpdatedElements["created"] = "dcterms:created";
    DocPropsAutoUpdatedElements["modified"] = "dcterms:modified";
})(DocPropsAutoUpdatedElements || (DocPropsAutoUpdatedElements = {}));
